import { useEffect, useState } from "react";
import { useSearchParams, Link, useNavigate } from "react-router-dom";
import api from "../lib/api";
import { Check, Loader2 } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState({ payment_status: "pending" });
  const [attempts, setAttempts] = useState(0);

  useEffect(() => {
    if (!sessionId) return;
    let cancelled = false;
    const poll = async () => {
      try {
        const r = await api.get(`/payments/status/${sessionId}`);
        if (cancelled) return;
        setStatus(r.data);
        if (r.data.payment_status === "paid" || r.data.payment_status === "failed" || attempts >= 20) return;
        setAttempts((a) => a + 1);
        setTimeout(poll, 2000);
      } catch { /* keep polling */ }
    };
    poll();
    return () => { cancelled = true; };
    // eslint-disable-next-line
  }, [sessionId]);

  const paid = status.payment_status === "paid";

  return (
    <div className="max-w-2xl mx-auto px-4 py-24 text-center">
      {paid ? (
        <>
          <div className="mx-auto w-16 h-16 bg-yellow-500 flex items-center justify-center mb-6">
            <Check size={36} className="text-black" />
          </div>
          <div className="text-xs font-mono-alt uppercase text-yellow-500 tracking-widest mb-2">Payment Successful</div>
          <h1 className="font-display text-5xl md:text-6xl uppercase leading-none">Your job is <span className="text-yellow-500">live</span></h1>
          <p className="text-zinc-400 mt-4">Featured for 30 days. Applicants can now find and apply to your listing.</p>
          <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
            {status.job_id && (
              <Link data-testid="success-view-job" to={`/jobs/${status.job_id}`} className="bg-yellow-500 text-black font-bold uppercase tracking-wider px-6 py-3 hover:bg-yellow-400 transition">
                View Your Listing
              </Link>
            )}
            <Link to="/jobs" className="border border-zinc-800 hover:border-yellow-500 text-zinc-300 uppercase tracking-wider text-sm px-6 py-3 transition">
              Browse All Jobs
            </Link>
          </div>
        </>
      ) : (
        <>
          <Loader2 size={40} className="animate-spin text-yellow-500 mx-auto mb-6" />
          <div className="text-xs font-mono-alt uppercase text-zinc-500 tracking-widest mb-2">Confirming payment</div>
          <h1 className="font-display text-4xl uppercase leading-none">Just a moment&hellip;</h1>
          <p className="text-zinc-500 mt-4 text-sm">Verifying with Stripe. This usually takes a few seconds.</p>
        </>
      )}
    </div>
  );
}
